import React, { useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';

import Title from './Title';
import TableLine from './TabLine';
import { ProcessusLog } from '../../../models/processusLog';

export default function TabLogs(props: { logs: ProcessusLog[] | null }) {
	const [currentPage, setCurrentPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [firstIndex, setfirstIndex] = useState(0);
	const [lastIndex, setLastIndex] = useState(rowsPerPage || 0);
	const [allLogs] = useState<ProcessusLog[] | null>(props.logs);

	const currentItems: ProcessusLog[] = allLogs ? allLogs.slice(firstIndex, lastIndex) : [];

	const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
		if (allLogs) {
			const lastIndex = (newPage + 1) * rowsPerPage < allLogs.length ? (newPage + 1) * rowsPerPage : allLogs.length;
			setLastIndex(lastIndex);
			setfirstIndex(newPage * rowsPerPage);
		}
		setCurrentPage(newPage);
	};

	const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		const rows = parseInt(event.target.value, 10);

		setLastIndex(rows);
		setRowsPerPage(rows);
		setfirstIndex(0);
		setCurrentPage(0);
	};

	return (
		<React.Fragment>
			<Title>Erreurs</Title>
			<Table size="small">
				<TableHead>
					<TableRow sx={{ textAlign: 'center' }}>
						<TableCell>Date</TableCell>
						<TableCell>Name</TableCell>
						<TableCell>Message</TableCell>
						<TableCell>Severity</TableCell>
						<TableCell>Stacktrace</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>{currentItems && currentItems.map((row: ProcessusLog, index: number) => <TableLine row={row} key={index} />)}</TableBody>
			</Table>
			{allLogs && <TablePagination component="div" count={allLogs.length} page={currentPage} onPageChange={handleChangePage} rowsPerPage={rowsPerPage} onRowsPerPageChange={handleChangeRowsPerPage} />}
		</React.Fragment>
	);
}
